import React from "react";

const Header = () => (
  <header>
    <p>Hello World! This ia a Parcel-React Starter template!</p>
  </header>
);

export default Header;
